<template>
  <h1>notifications</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>